import { Button } from '@mui/material';

import { CandidateStatus, Strings } from '@app/constants';
import { AttachmentViewer, ProfileCard } from '@app/components/card';
import { ICandidateData } from '../types';
import { useDialog } from '@app/hooks';

interface Props {
  candidateData?: ICandidateData;
}
export const ProfileInfo = ({ candidateData }: Props) => {
  const viewResumePreview = useDialog();

  const fields = [
    Strings.field.firstName,
    Strings.field.lastName,
    Strings.field.phone,
    Strings.field.email,
    Strings.field.source,
    Strings.field.resume,
    Strings.field.reason,
    Strings.field.status,
  ];
  const data = [
    candidateData?.firstName ?? 'NA',
    candidateData?.lastName ?? 'NA',
    candidateData?.phone ? candidateData?.phone : 'NA',
    candidateData?.email ?? 'NA',
    candidateData?.source === 'Other'
      ? candidateData?.other ?? 'NA'
      : candidateData?.source === 'Reference'
      ? `Reference By ${candidateData?.referenceBy ?? 'NA'}`
      : candidateData?.source ?? 'NA',
    <Button key="resume" color="primary" onClick={viewResumePreview.show} sx={{ padding: 0 }}>
      {Strings.button.clickHere}
    </Button>,
    candidateData?.reason ?? 'NA',
    candidateData?.status.toLowerCase() === 'active'
      ? CandidateStatus.Shortlisted
      : candidateData?.status,
  ];
  return (
    <>
      <ProfileCard
        fields={fields}
        data={data}
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        Src={`${candidateData?.firstName} ${candidateData?.lastName}`}
        title={Strings.profile.personalInformation}
      />
      {viewResumePreview.visible && (
        <AttachmentViewer open onClose={viewResumePreview.hide} resume={candidateData?.resume} />
      )}
    </>
  );
};
